export default "__VITE_ASSET__DbVx7qfw__"